import React from "react";
import { Link } from "react-router-dom";
import './index.css';
import logo from "../../images/logo.png";
import header_bg from "../../images/header_bg.png"
import uni_logo from "../../images/uni_logo.jpg"
import verizon_logo from "../../images/verizon_logo.png"
import { Image, Menu, Avatar, Dropdown } from 'antd';
import { getUser, isLoggedIn } from "../../services/api";
import { profileHelper } from "../../services/profileHelper";
class WhiteHeader extends React.Component {
    constructor(props) {
        super(props);

        this.isLoggedIn = isLoggedIn();
        if (this.isLoggedIn) {
            this.user = getUser();

            this.bg = profileHelper(this.user.email.charAt(0));
        }

        this.state = {
            isLoggedIn: this.isLoggedIn || false,
            avatarBg: this.bg || "#fff",
            avatarChar: this.user?.email.charAt(0),
            firstName: this.user?.name,
        };

        this.handleLogout = this.handleLogout.bind(this)
    };

    handleLogout = () => {
        localStorage.clear();
        window.location.href = window.location.origin + '/login'
    }

    render() {

        const menu = (
            <Menu>
                <Menu.Item id="my_profile">
                    <p className="mb-0 py-0 px-3" onClick={(e) => this.handleLogout()}>
                        Logout
                    </p>
                </Menu.Item>
            </Menu>
        );

        return (
            <>
                <div className="d-flex justify-content-between align-items-center" style={{ background: `#fff`, color: 'black', padding: "0.75rem 3rem", top: 0, left: 0, right: 0, position: "fixed", width: "100%", zIndex: 100, boxShadow: "rgb(0 0 0 / 60%) 0px 1px 4px -1px" }}>                    
                    { <Image preview={false} src={uni_logo} /> }
                    {this.state.isLoggedIn ?
                        <div className="mb-0" style={{ color: '#354052', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' }} >
                            <Dropdown
                                overlay={menu}
                                trigger={'click'}
                                placement="bottomLeft"
                                arrow
                            >
                                <div className="mb-0" >
                                    {<Avatar style={{ backgroundColor: this.state.avatarBg, verticalAlign: 'middle', cursor: 'pointer' }} size="large" gap="4">{this.state.avatarChar.toUpperCase()}</Avatar>} {this.state.firstName}
                                </div>
                            </Dropdown>
                        </div>
                        :
                        ""
                    }

                </div>
            </>
        )
    }
}

export default function WhiteHeaders() {
    return (
        <WhiteHeader />
    )
}
